import request from '@/utils/request'
import qs from 'qs'

// 获取公司仪表盘数据
export function getCompanyDashboard(params) {
  return request({
    url: '/system/dept/companyDashboard',
    method: 'get',
    params,
  })
}

// 查询任务详情分页数据
export function getTaskPage(params) {
  return request({
    url: '/system/dept/taskPage',
    method: 'get',
    params,
    paramsSerializer: (p) => qs.stringify(p, { indices: false }),
  })
}

// 任务详情人员选项（含完成率）
export function getTaskUserOptions(params) {
  return request({
    url: '/system/dept/taskUserOptions',
    method: 'get',
    params,
  })
}

// 任务详情导出
export function exportTaskPage(params) {
  return request({
    url: '/system/dept/taskExport',
    method: 'post',
    data: params,
  })
}

// 查询手环详情分页数据
export function getWristbandPage(params) {
  return request({
    url: '/system/dept/wristbandPage',
    method: 'get',
    params,
  })
}

// 查询出勤详情分页数据
export function getAttendancePage(params) {
  return request({
    url: '/system/dept/attendancePage',
    method: 'get',
    params,
  })
}

// 查询投诉详情分页数据
export function getComplaintPage(params) {
  return request({
    url: '/system/dept/complaintPage',
    method: 'get',
    params,
  })
}

export const taskPage = getTaskPage
export const taskUserOptions = getTaskUserOptions
export const attendancePage = getAttendancePage
export const complaintPage = getComplaintPage

// 查询健康预警详情分页数据
export function getHealthAlertPage(params) {
  return request({
    url: '/system/dept/healthAlertPage',
    method: 'get',
    params,
  })
}

// 查询最新消息分页数据
export function getMessagePage(params) {
  return request({
    url: '/system/dept/messagePage',
    method: 'get',
    params,
  })
}

// 查询参数列表
export function pageDept(query) {
  return request({
    url: '/system/dept/page',
    method: 'get',
    params: query,
  })
}

// 查询部门列表
export function listDept(query) {
  return request({
    url: '/system/dept/list',
    method: 'get',
    params: query,
  })
}

// 查询部门列表（排除节点）
export function listDeptExcludeChild(deptId) {
  return request({
    url: '/system/dept/list/exclude/' + deptId,
    method: 'get',
  })
}

// 查询部门详细
export function getDept(data) {
  return request({
    url: '/system/dept/detail',
    method: 'get',
    params: data,
  })
}

// 新增部门
export function addDept(data) {
  return request({
    url: '/system/dept/add',
    method: 'post',
    data: data,
  })
}

// 修改部门
export function updateDept(data) {
  return request({
    url: '/system/dept/edit',
    method: 'post',
    data: data,
  })
}

// 导入用户
export function importData(data) {
  return request({
    url: '/system/dept/importData',
    method: 'post',
    data: data,
  })
}

// 删除部门
// export function delDept(deptId) {
//   return request({
//     url: '/system/dept/' + deptId,
//     method: 'delete',
//   })
// }

export function delDept(data) {
  return request({
    url: '/system/dept/delete',
    method: 'post',
    data
  })
}

/**
 * 刷新百度 token：请求百度 OAuth 获取新 access_token 并保存到 zb_baidu_card
 */
export function refreshBaiduToken() {
  return request({
    url: '/system/baidu-card/refresh',
    method: 'get'
  })
}
